// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonStyles-module__font-s-10___pF4nC {
  font-size: 10px !important;
}

.commonStyles-module__font-s-12___xGJeM {
  font-size: 12px !important;
}

.commonStyles-module__font-s-13___qARQG {
  font-size: 13px !important;
}

.commonStyles-module__font-s-14___uchXO {
  font-size: 14px !important;
}

.commonStyles-module__font-s-15___f1luC {
  font-size: 15px !important;
}

.commonStyles-module__font-s-16___LQqWP {
  font-size: 16px !important;
}

.commonStyles-module__font-s-18___WQeeA {
  font-size: 18px !important;
}

.commonStyles-module__font-s-20___d_Owc {
  font-size: 20px !important;
}

.commonStyles-module__font-s-22___JcfJF {
  font-size: 22px !important;
}

.commonStyles-module__font-s-28___zFxCG {
  font-size: 28px !important;
}

.commonStyles-module__font-w-400___DBJZB {
  font-weight: 400 !important;
}

.commonStyles-module__font-w-500___lgmE4 {
  font-weight: 500 !important;
}

.commonStyles-module__font-w-600___H35uw {
  font-weight: 600 !important;
}

.commonStyles-module__font-w-700___kYBKg {
  font-weight: 700 !important;
}

.commonStyles-module__p-5___vHq_y {
  padding: 5px !important;
}

.commonStyles-module__p-12___FNqzb {
  padding: 12px !important;
}

.commonStyles-module__p-16___oxyrb {
  padding: 16px !important;
}

.commonStyles-module__p-30___BRpSv {
  padding: 30px !important;
}

.commonStyles-module__p-b-0___NUqV1 {
  padding-bottom: 0 !important;
}

.commonStyles-module__p-b-5___Km0Uh {
  padding-bottom: 5px !important;
}

.commonStyles-module__p-b-10___vRMiH {
  padding-bottom: 10px !important;
}

.commonStyles-module__p-b-12___BlKnN {
  padding-bottom: 12px !important;
}

.commonStyles-module__p-b-16___md7aH {
  padding-bottom: 16px !important;
}

.commonStyles-module__p-b-18___vpWvb {
  padding-bottom: 18px !important;
}

.commonStyles-module__p-b-20___dyzsU {
  padding-bottom: 20px !important;
}

.commonStyles-module__p-b-25___MapWt {
  padding-bottom: 25px !important;
}

.commonStyles-module__p-b-30___p8wk_ {
  padding-bottom: 30px !important;
}

.commonStyles-module__p-b-50____DL54 {
  padding-bottom: 50px !important;
}

.commonStyles-module__p-t-0___EoSHw {
  padding-top: 0 !important;
}

.commonStyles-module__p-t-12___MgyoM {
  padding-top: 12px !important;
}

.commonStyles-module__p-t-16___W4xi0 {
  padding-top: 16px !important;
}

.commonStyles-module__p-t-18___ZAtyk {
  padding-top: 18px !important;
}

.commonStyles-module__p-t-20___Fgaw9 {
  padding-top: 20px !important;
}

.commonStyles-module__p-t-30____99Kz {
  padding-top: 30px !important;
}

.commonStyles-module__p-t-40___BBVHZ {
  padding-top: 40px !important;
}

.commonStyles-module__p-t-50___usxzt {
  padding-top: 50px !important;
}

.commonStyles-module__p-l-20___vSxby {
  padding-left: 20px !important;
}

.commonStyles-module__p-l-30___fTUjj {
  padding-left: 30px !important;
}

.commonStyles-module__p-l-40___YVTgV {
  padding-left: 40px !important;
}

.commonStyles-module__p-r-16___JCuPG {
  padding-right: 16px !important;
}

.commonStyles-module__p-r-20___oUCeC {
  padding-right: 20px !important;
}

.commonStyles-module__p-r-30___yG0Va {
  padding-right: 30px !important;
}

.commonStyles-module__p-r-50___lUVvC {
  padding-right: 50px !important;
}

.commonStyles-module__p-r-60___NgVW2 {
  padding-right: 60px !important;
}

.commonStyles-module__m-b-1___FECGv {
  margin-bottom: 1px !important;
}

.commonStyles-module__m-b-2___fuiL9 {
  margin-bottom: 2px !important;
}

.commonStyles-module__m-b-6___uTgZy {
  margin-bottom: 6px !important;
}

.commonStyles-module__m-b-8___T7u1S {
  margin-bottom: 8px !important;
}

.commonStyles-module__m-b-10___O6DFB {
  margin-bottom: 10px !important;
}

.commonStyles-module__m-b-14___ev3dq {
  margin-bottom: 14px !important;
}

.commonStyles-module__m-b-16___TEKLl {
  margin-bottom: 16px !important;
}

.commonStyles-module__m-b-20___hMBhB {
  margin-bottom: 20px !important;
}

.commonStyles-module__m-b-22___e8c4U {
  margin-bottom: 22px !important;
}

.commonStyles-module__m-b-24___EMd5H {
  margin-bottom: 24px !important;
}

.commonStyles-module__m-b-30___erN89 {
  margin-bottom: 30px !important;
}

.commonStyles-module__m-b-32___oxkR2 {
  margin-bottom: 32px !important;
}

.commonStyles-module__m-b-40___i5xFG {
  margin-bottom: 40px !important;
}

.commonStyles-module__m-t-2___DJcG2 {
  margin-top: 2px !important;
}

.commonStyles-module__m-t-3___jt8vr {
  margin-top: 3px !important;
}

.commonStyles-module__m-t-4___w_IHs {
  margin-top: 4px !important;
}

.commonStyles-module__m-t-5___y_yFX {
  margin-top: 5px !important;
}

.commonStyles-module__m-t-8___vCeZU {
  margin-top: 8px !important;
}

.commonStyles-module__m-t-10___BX06d {
  margin-top: 10px !important;
}

.commonStyles-module__m-t-15___MIpgX {
  margin-top: 15px !important;
}

.commonStyles-module__m-t-16___lPRGf {
  margin-top: 16px !important;
}

.commonStyles-module__m-t-20___o32oX {
  margin-top: 20px !important;
}

.commonStyles-module__m-t-22___cVYAj {
  margin-top: 22px !important;
}

.commonStyles-module__m-t-30___QVLV7 {
  margin-top: 30px !important;
}

.commonStyles-module__m-t-32___NFidj {
  margin-top: 32px !important;
}

.commonStyles-module__m-l-auto___NOlmx {
  margin-left: auto !important;
}

.commonStyles-module__m-l-4___BruwT {
  margin-left: 4px !important;
}

.commonStyles-module__m-l-5___rjqIK {
  margin-left: 5px !important;
}

.commonStyles-module__m-l-6___assHW {
  margin-left: 6px !important;
}

.commonStyles-module__m-l-8___qEw_3 {
  margin-left: 8px !important;
}

.commonStyles-module__m-l-10___d4CvS {
  margin-left: 10px !important;
}

.commonStyles-module__m-l-16___EMjQp {
  margin-left: 16px !important;
}

.commonStyles-module__m-l-20___DCrjl {
  margin-left: 20px !important;
}

.commonStyles-module__m-l-24___vK8yF {
  margin-left: 24px !important;
}

.commonStyles-module__m-l-30___KpCMj {
  margin-left: 30px !important;
}

.commonStyles-module__m-l-35___Wv70L {
  margin-left: 35px !important;
}

.commonStyles-module__m-l-40___ddc0F {
  margin-left: 40px !important;
}

.commonStyles-module__m-r-8___KmNuI {
  margin-right: 8px !important;
}

.commonStyles-module__m-r-10___cjvaP {
  margin-right: 10px !important;
}

.commonStyles-module__m-r-16___Kvg76 {
  margin-right: 16px !important;
}

.commonStyles-module__m-r-20___PNTOb {
  margin-right: 20px !important;
}

.commonStyles-module__m-r-24___a1IjI {
  margin-right: 24px !important;
}

.commonStyles-module__m-r-30___b5riy {
  margin-right: 30px !important;
}

.commonStyles-module__m-r-40___SJywb {
  margin-right: 40px !important;
}

.commonStyles-module__border-r-3____eVLX {
  border-radius: 3px !important;
}

.commonStyles-module__border-r-4___uE4UZ {
  border-radius: 4px !important;
}

.commonStyles-module__border-r-6___GrQBH {
  border-radius: 6px !important;
}

.commonStyles-module__border-r-10___RbzYv {
  border-radius: 10px !important;
}

.commonStyles-module__border-r-12___opAt7 {
  border-radius: 12px !important;
}

.commonStyles-module__border-r-16___cibpT {
  border-radius: 16px !important;
}

.commonStyles-module__border-r-50___VkiOc {
  border-radius: 50% !important;
}

.commonStyles-module__primary-border___Ic202 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-b___i1MCI {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-t___AzKqW {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-l___yg0Xd {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-r___OkawC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__secondary-border___qc1nU {
  border: 1px solid #637768;
}

.commonStyles-module__secondary-border-b___DN0OF {
  border-bottom: 1px solid #637768;
}

.commonStyles-module__secondary-border-t___pDByI {
  border-top: 1px solid #637768;
}

.commonStyles-module__secondary-border-l___tMjuS {
  border-left: 1px solid #637768;
}

.commonStyles-module__secondary-border-r___bOAwJ {
  border-right: 1px solid #637768;
}

.commonStyles-module__gap-0___O3vfF {
  gap: 0 !important;
}

.commonStyles-module__gap-2___BT0xn {
  gap: 2px !important;
}

.commonStyles-module__gap-4___JYNll {
  gap: 4px !important;
}

.commonStyles-module__gap-5___OEVci {
  gap: 5px !important;
}

.commonStyles-module__gap-6___LJA7N {
  gap: 6px !important;
}

.commonStyles-module__gap-8___FmdgO {
  gap: 8px !important;
}

.commonStyles-module__gap-10___crWkH {
  gap: 10px !important;
}

.commonStyles-module__gap-12___dQMyu {
  gap: 12px !important;
}

.commonStyles-module__gap-14___KZgav {
  gap: 14px !important;
}

.commonStyles-module__gap-16___s_lHw {
  gap: 16px !important;
}

.commonStyles-module__gap-18___tzWOq {
  gap: 18px !important;
}

.commonStyles-module__gap-20___ulM14 {
  gap: 20px !important;
}

.commonStyles-module__gap-24___juIkP {
  gap: 24px !important;
}

.commonStyles-module__gap-26___znbpO {
  gap: 26px !important;
}

.commonStyles-module__gap-30___JNcNk {
  gap: 30px !important;
}

.commonStyles-module__gap-32___Bl23Z {
  gap: 32px !important;
}

.commonStyles-module__gap-40___RhKbd {
  gap: 40px !important;
}

.commonStyles-module__gap-50___mzTmQ {
  gap: 50px !important;
}

.commonStyles-module__flex-1___IGyeQ {
  flex: 1;
}

.commonStyles-module__flex-none___Phl0p {
  flex: none !important;
}

.commonStyles-module__flex-column___UjWau {
  display: flex;
  flex-direction: column !important;
}

.commonStyles-module__flex-row___iUHj7 {
  display: flex;
  flex-direction: row !important;
}

.commonStyles-module__vertically-centered___r2Su5 {
  display: flex;
  align-items: center !important;
}

.commonStyles-module__horizontally-centered___ouAXL {
  display: flex;
  justify-content: center !important;
}

.commonStyles-module__horizontally-end___vspNm {
  display: flex;
  justify-content: end !important;
}

.commonStyles-module__vertically-start___l9Vfx {
  display: flex;
  align-items: start !important;
}

.commonStyles-module__space-between___ipvNy {
  display: flex;
  justify-content: space-between !important;
}

.commonStyles-module__flex-wrap___ZNXkl {
  flex-wrap: wrap !important;
}

.commonStyles-module__height-100___x5PB7 {
  height: 100%;
}

.commonStyles-module__width-50___P3jMi {
  width: 50% !important;
}

.commonStyles-module__width-100___bgRSI {
  width: 100%;
}

.commonStyles-module__cursor-pointer___AsGrj {
  cursor: pointer;
}

.commonStyles-module__cursor-not-allowed___eH57G {
  cursor: not-allowed !important;
}

.commonStyles-module__absolute-centered___SB6RY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.commonStyles-module__absolute___mQjyv {
  position: absolute;
}

.commonStyles-module__relative___XjUSO {
  position: relative;
}

.commonStyles-module__fixed___KxRq1 {
  position: fixed;
}

.commonStyles-module__visible___kJRYj {
  opacity: 1;
}

.commonStyles-module__invisible___cc62Y {
  opacity: 0;
}

.commonStyles-module__col-90___LRRPf {
  width: 90% !important;
}

.commonStyles-module__col-auto___thFFz {
  width: auto !important;
}

.commonStyles-module__medical-tabs___LJotv {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.commonStyles-module__medical-table-new___fdW2B {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___fdW2B:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___fdW2B::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___fdW2B::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__medical-table-new___fdW2B.commonStyles-module__no-pagination___Y1Wt3 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___fdW2B.commonStyles-module__no-pagination___Y1Wt3:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___fdW2B.commonStyles-module__no-pagination___Y1Wt3::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___fdW2B.commonStyles-module__no-pagination___Y1Wt3::-webkit-scrollbar-track {
  display: none;
}

.commonStyles-module__medical-table-empty___EKkHX {
  padding: 14px 40px !important;
}

.commonStyles-module__icon-btn___jXSQN {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.commonStyles-module__search-icon___lVLnW {
  width: 24px;
  height: 24px;
  align-self: center;
}

.commonStyles-module__disable-select___Ggf2b {
  user-select: none;
}

.commonStyles-module__break-word___UT2ih {
  word-break: break-word;
}

.commonStyles-module__popup-clear-btn___py7QS {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.commonStyles-module__scroll-m-b-20___skdKR {
  scroll-margin-bottom: 20px;
}

.commonStyles-module__width75___Z7s9O {
  grid-column: 2 span;
}

.commonStyles-module__option___AleJ5 {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/AddPlanPopup/forms/commonStyles.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mBAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.width75 {\n  grid-column: 2 span;\n}\n\n.option {\n  color: get-color(greenNew, dark);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `commonStyles-module__font-s-10___pF4nC`,
	"fontS12": `commonStyles-module__font-s-12___xGJeM`,
	"fontS13": `commonStyles-module__font-s-13___qARQG`,
	"fontS14": `commonStyles-module__font-s-14___uchXO`,
	"fontS15": `commonStyles-module__font-s-15___f1luC`,
	"fontS16": `commonStyles-module__font-s-16___LQqWP`,
	"fontS18": `commonStyles-module__font-s-18___WQeeA`,
	"fontS20": `commonStyles-module__font-s-20___d_Owc`,
	"fontS22": `commonStyles-module__font-s-22___JcfJF`,
	"fontS28": `commonStyles-module__font-s-28___zFxCG`,
	"fontW400": `commonStyles-module__font-w-400___DBJZB`,
	"fontW500": `commonStyles-module__font-w-500___lgmE4`,
	"fontW600": `commonStyles-module__font-w-600___H35uw`,
	"fontW700": `commonStyles-module__font-w-700___kYBKg`,
	"p5": `commonStyles-module__p-5___vHq_y`,
	"p12": `commonStyles-module__p-12___FNqzb`,
	"p16": `commonStyles-module__p-16___oxyrb`,
	"p30": `commonStyles-module__p-30___BRpSv`,
	"pB0": `commonStyles-module__p-b-0___NUqV1`,
	"pB5": `commonStyles-module__p-b-5___Km0Uh`,
	"pB10": `commonStyles-module__p-b-10___vRMiH`,
	"pB12": `commonStyles-module__p-b-12___BlKnN`,
	"pB16": `commonStyles-module__p-b-16___md7aH`,
	"pB18": `commonStyles-module__p-b-18___vpWvb`,
	"pB20": `commonStyles-module__p-b-20___dyzsU`,
	"pB25": `commonStyles-module__p-b-25___MapWt`,
	"pB30": `commonStyles-module__p-b-30___p8wk_`,
	"pB50": `commonStyles-module__p-b-50____DL54`,
	"pT0": `commonStyles-module__p-t-0___EoSHw`,
	"pT12": `commonStyles-module__p-t-12___MgyoM`,
	"pT16": `commonStyles-module__p-t-16___W4xi0`,
	"pT18": `commonStyles-module__p-t-18___ZAtyk`,
	"pT20": `commonStyles-module__p-t-20___Fgaw9`,
	"pT30": `commonStyles-module__p-t-30____99Kz`,
	"pT40": `commonStyles-module__p-t-40___BBVHZ`,
	"pT50": `commonStyles-module__p-t-50___usxzt`,
	"pL20": `commonStyles-module__p-l-20___vSxby`,
	"pL30": `commonStyles-module__p-l-30___fTUjj`,
	"pL40": `commonStyles-module__p-l-40___YVTgV`,
	"pR16": `commonStyles-module__p-r-16___JCuPG`,
	"pR20": `commonStyles-module__p-r-20___oUCeC`,
	"pR30": `commonStyles-module__p-r-30___yG0Va`,
	"pR50": `commonStyles-module__p-r-50___lUVvC`,
	"pR60": `commonStyles-module__p-r-60___NgVW2`,
	"mB1": `commonStyles-module__m-b-1___FECGv`,
	"mB2": `commonStyles-module__m-b-2___fuiL9`,
	"mB6": `commonStyles-module__m-b-6___uTgZy`,
	"mB8": `commonStyles-module__m-b-8___T7u1S`,
	"mB10": `commonStyles-module__m-b-10___O6DFB`,
	"mB14": `commonStyles-module__m-b-14___ev3dq`,
	"mB16": `commonStyles-module__m-b-16___TEKLl`,
	"mB20": `commonStyles-module__m-b-20___hMBhB`,
	"mB22": `commonStyles-module__m-b-22___e8c4U`,
	"mB24": `commonStyles-module__m-b-24___EMd5H`,
	"mB30": `commonStyles-module__m-b-30___erN89`,
	"mB32": `commonStyles-module__m-b-32___oxkR2`,
	"mB40": `commonStyles-module__m-b-40___i5xFG`,
	"mT2": `commonStyles-module__m-t-2___DJcG2`,
	"mT3": `commonStyles-module__m-t-3___jt8vr`,
	"mT4": `commonStyles-module__m-t-4___w_IHs`,
	"mT5": `commonStyles-module__m-t-5___y_yFX`,
	"mT8": `commonStyles-module__m-t-8___vCeZU`,
	"mT10": `commonStyles-module__m-t-10___BX06d`,
	"mT15": `commonStyles-module__m-t-15___MIpgX`,
	"mT16": `commonStyles-module__m-t-16___lPRGf`,
	"mT20": `commonStyles-module__m-t-20___o32oX`,
	"mT22": `commonStyles-module__m-t-22___cVYAj`,
	"mT30": `commonStyles-module__m-t-30___QVLV7`,
	"mT32": `commonStyles-module__m-t-32___NFidj`,
	"mLAuto": `commonStyles-module__m-l-auto___NOlmx`,
	"mL4": `commonStyles-module__m-l-4___BruwT`,
	"mL5": `commonStyles-module__m-l-5___rjqIK`,
	"mL6": `commonStyles-module__m-l-6___assHW`,
	"mL8": `commonStyles-module__m-l-8___qEw_3`,
	"mL10": `commonStyles-module__m-l-10___d4CvS`,
	"mL16": `commonStyles-module__m-l-16___EMjQp`,
	"mL20": `commonStyles-module__m-l-20___DCrjl`,
	"mL24": `commonStyles-module__m-l-24___vK8yF`,
	"mL30": `commonStyles-module__m-l-30___KpCMj`,
	"mL35": `commonStyles-module__m-l-35___Wv70L`,
	"mL40": `commonStyles-module__m-l-40___ddc0F`,
	"mR8": `commonStyles-module__m-r-8___KmNuI`,
	"mR10": `commonStyles-module__m-r-10___cjvaP`,
	"mR16": `commonStyles-module__m-r-16___Kvg76`,
	"mR20": `commonStyles-module__m-r-20___PNTOb`,
	"mR24": `commonStyles-module__m-r-24___a1IjI`,
	"mR30": `commonStyles-module__m-r-30___b5riy`,
	"mR40": `commonStyles-module__m-r-40___SJywb`,
	"borderR3": `commonStyles-module__border-r-3____eVLX`,
	"borderR4": `commonStyles-module__border-r-4___uE4UZ`,
	"borderR6": `commonStyles-module__border-r-6___GrQBH`,
	"borderR10": `commonStyles-module__border-r-10___RbzYv`,
	"borderR12": `commonStyles-module__border-r-12___opAt7`,
	"borderR16": `commonStyles-module__border-r-16___cibpT`,
	"borderR50": `commonStyles-module__border-r-50___VkiOc`,
	"primaryBorder": `commonStyles-module__primary-border___Ic202`,
	"primaryBorderB": `commonStyles-module__primary-border-b___i1MCI`,
	"primaryBorderT": `commonStyles-module__primary-border-t___AzKqW`,
	"primaryBorderL": `commonStyles-module__primary-border-l___yg0Xd`,
	"primaryBorderR": `commonStyles-module__primary-border-r___OkawC`,
	"secondaryBorder": `commonStyles-module__secondary-border___qc1nU`,
	"secondaryBorderB": `commonStyles-module__secondary-border-b___DN0OF`,
	"secondaryBorderT": `commonStyles-module__secondary-border-t___pDByI`,
	"secondaryBorderL": `commonStyles-module__secondary-border-l___tMjuS`,
	"secondaryBorderR": `commonStyles-module__secondary-border-r___bOAwJ`,
	"gap0": `commonStyles-module__gap-0___O3vfF`,
	"gap2": `commonStyles-module__gap-2___BT0xn`,
	"gap4": `commonStyles-module__gap-4___JYNll`,
	"gap5": `commonStyles-module__gap-5___OEVci`,
	"gap6": `commonStyles-module__gap-6___LJA7N`,
	"gap8": `commonStyles-module__gap-8___FmdgO`,
	"gap10": `commonStyles-module__gap-10___crWkH`,
	"gap12": `commonStyles-module__gap-12___dQMyu`,
	"gap14": `commonStyles-module__gap-14___KZgav`,
	"gap16": `commonStyles-module__gap-16___s_lHw`,
	"gap18": `commonStyles-module__gap-18___tzWOq`,
	"gap20": `commonStyles-module__gap-20___ulM14`,
	"gap24": `commonStyles-module__gap-24___juIkP`,
	"gap26": `commonStyles-module__gap-26___znbpO`,
	"gap30": `commonStyles-module__gap-30___JNcNk`,
	"gap32": `commonStyles-module__gap-32___Bl23Z`,
	"gap40": `commonStyles-module__gap-40___RhKbd`,
	"gap50": `commonStyles-module__gap-50___mzTmQ`,
	"flex1": `commonStyles-module__flex-1___IGyeQ`,
	"flexNone": `commonStyles-module__flex-none___Phl0p`,
	"flexColumn": `commonStyles-module__flex-column___UjWau`,
	"flexRow": `commonStyles-module__flex-row___iUHj7`,
	"verticallyCentered": `commonStyles-module__vertically-centered___r2Su5`,
	"horizontallyCentered": `commonStyles-module__horizontally-centered___ouAXL`,
	"horizontallyEnd": `commonStyles-module__horizontally-end___vspNm`,
	"verticallyStart": `commonStyles-module__vertically-start___l9Vfx`,
	"spaceBetween": `commonStyles-module__space-between___ipvNy`,
	"flexWrap": `commonStyles-module__flex-wrap___ZNXkl`,
	"height100": `commonStyles-module__height-100___x5PB7`,
	"width50": `commonStyles-module__width-50___P3jMi`,
	"width100": `commonStyles-module__width-100___bgRSI`,
	"cursorPointer": `commonStyles-module__cursor-pointer___AsGrj`,
	"cursorNotAllowed": `commonStyles-module__cursor-not-allowed___eH57G`,
	"absoluteCentered": `commonStyles-module__absolute-centered___SB6RY`,
	"absolute": `commonStyles-module__absolute___mQjyv`,
	"relative": `commonStyles-module__relative___XjUSO`,
	"fixed": `commonStyles-module__fixed___KxRq1`,
	"visible": `commonStyles-module__visible___kJRYj`,
	"invisible": `commonStyles-module__invisible___cc62Y`,
	"col90": `commonStyles-module__col-90___LRRPf`,
	"colAuto": `commonStyles-module__col-auto___thFFz`,
	"medicalTabs": `commonStyles-module__medical-tabs___LJotv`,
	"medicalTableNew": `commonStyles-module__medical-table-new___fdW2B`,
	"noPagination": `commonStyles-module__no-pagination___Y1Wt3`,
	"medicalTableEmpty": `commonStyles-module__medical-table-empty___EKkHX`,
	"iconBtn": `commonStyles-module__icon-btn___jXSQN`,
	"searchIcon": `commonStyles-module__search-icon___lVLnW`,
	"disableSelect": `commonStyles-module__disable-select___Ggf2b`,
	"breakWord": `commonStyles-module__break-word___UT2ih`,
	"popupClearBtn": `commonStyles-module__popup-clear-btn___py7QS`,
	"scrollMB20": `commonStyles-module__scroll-m-b-20___skdKR`,
	"width75": `commonStyles-module__width75___Z7s9O`,
	"option": `commonStyles-module__option___AleJ5`
};
module.exports = ___CSS_LOADER_EXPORT___;
